// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"cec6640a","162":"721fd160","435":"c10a6de3","457":"b21cc4b0","671":"fa4d60d2","674":"7cf380f7","940":"1e3b0498"}[chunkId] + ".chunk.js";
};